module.exports = __webpack_public_path__ + "static/media/notification2.4ab937d5.mp3";